module.exports = __webpack_public_path__ + "img/sv50.dbd07303.svg";